import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/permits')({
  component: undefined,
  context: () => ({
    getBreadcrumbData: () => ({
      id: null,
      translationKey: 'breadcrumbs.permits',
    }),
  }),
  beforeLoad: ({ location }) => {
    if (location.pathname === '/registry/permits') {
      throw redirect({
        to: '/dashboard/permits',
      });
    }
  },
});
